function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "index-desktop-copy-6",
  transform: "translate(-796.000000, -875.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-3",
  transform: "translate(797.000000, 875.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Watch_2218663",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.9063246,7.10542736e-15 L5.21953941,7.10542736e-15 C4.80704718,7.10542736e-15 4.47265615,0.330160349 4.47265615,0.737433779 L4.47265615,12.1884087 C1.65783927,14.4347937 0.0155399004,17.8120145 0.000106686273,21.3855271 C-0.0151101238,24.9590397 1.59816444,28.349871 4.39361349,30.6197106 L4.55653861,42.1878343 C4.56219943,42.5911335 4.89491557,42.9151874 5.30342187,42.9151874 L5.31399774,42.9151874 L18.999319,42.7239855 C19.411684,42.7182584 19.7413048,42.3836205 19.7356264,41.976471 L19.5772871,30.7342931 C22.4375939,28.4908771 24.1109092,25.0860612 24.1257768,21.4793524 C24.1404473,17.8726437 22.4950707,14.4545799 19.6532302,12.1884014 L19.6532302,0.737433779 C19.6532302,0.541850348 19.5745379,0.354277828 19.4344653,0.215981531 C19.2943926,0.0776852352 19.1044142,7.10542736e-15 18.9063246,7.10542736e-15 Z M5.96642267,1.47486756 L18.1594413,1.47486756 L18.1594413,11.1738105 C14.4006916,8.97309054 9.72517233,8.97309054 5.96642267,11.1738105 L5.96642267,1.47486756 Z M18.23165,41.2595674 L6.03972926,41.4299146 L5.90219071,31.6542049 C9.64747598,33.8788456 14.3238674,33.9079466 18.0972558,31.7300942 L18.23165,41.2595674 Z M18.6484108,29.5813449 C18.4538748,29.6276151 18.2871399,29.7507742 18.1872627,29.9219729 C14.7457719,32.3850192 10.1412004,32.5611966 6.51697955,30.3684944 C2.89275869,28.1757923 0.961102301,24.0451095 1.62119776,19.8992597 L11.8692801,22.6242176 C11.9966317,22.657825 12.1306887,22.657825 12.2580403,22.6242176 L22.5046662,19.8992597 C23.0938429,23.5784054 21.6179623,27.283944 18.6483959,29.5813154 L18.6484108,29.5813449 Z M22.1878906,18.4557478 L12.0636789,21.1482955 L1.93802564,18.4556962 C3.26990902,14.0316721 7.3884784,10.9981285 12.0629524,10.9981285 C16.7374265,10.9981285 20.8559823,14.0317105 22.1878906,18.4557404 L22.1878906,18.4557478 Z",
  id: "Shape",
  fill: "#AEAEAE"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  stroke: "#AEAEAE",
  fill: "#FFFFFF",
  cx: 11.9900932,
  cy: 21.2121224,
  rx: 11.9318182,
  ry: 11.8461538
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  x: 11,
  y: 16,
  width: 2,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7144372,20.28565 C14.172455,20.2890634 14.5428046,20.6597225 14.5458353,21.1177429 L14.5846262,26.9800624 C14.5876024,27.4298422 14.2253965,27.7968735 13.7756167,27.7998497 C13.7717974,27.7998749 13.7679779,27.7998733 13.7641586,27.7998449 C13.3061409,27.7964315 12.9357913,27.4257725 12.9327606,26.967752 L12.8939696,21.1054325 C12.8909935,20.6556527 13.2531994,20.2886214 13.7029792,20.2856452 C13.7067985,20.28562 13.7106179,20.2856216 13.7144372,20.28565 Z",
  id: "Rectangle-Copy",
  fill: "#000000",
  transform: "translate(13.739298, 24.042747) rotate(-40.000000) translate(-13.739298, -24.042747) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#AEAEAE",
  x: 24,
  y: 19,
  width: 2,
  height: 5,
  rx: 1
}))));
function SvgWatchIconPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "43px",
    viewBox: "0 0 27 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIconPointer);
export default __webpack_public_path__ + "static/media/watch-icon-pointer.304cdcea4d2650ecefce583a59a35ebc.svg";
export { ForwardRef as ReactComponent };